import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getNewbuildingChatSrc } from './utils';
import { closeChat } from '../../../actions/chat';
import { ChatPopup } from '../../../components/ChatPopup';
import { selectNewbuildingLayoutDetailsModalOpen } from '../../../selectors/newbuildingLayouts';
import { selectChat } from '../../../selectors/selectChat';

import type { TContactParam } from '@cian/newbuilding-chat-component';

export const NewbuildingChatPopupContainer: React.FC = () => {
  const dispatch = useDispatch();

  const { isOpened, newbuildingContact } = useSelector(selectChat);
  const isLayoutDetailsModalOpen = useSelector(selectNewbuildingLayoutDetailsModalOpen);

  const onClose = React.useCallback(() => dispatch(closeChat()), [dispatch]);

  if (!isOpened) {
    return null;
  }

  const src = getNewbuildingChatSrc(newbuildingContact as TContactParam);

  return <ChatPopup src={src} onClose={onClose} aboveModal={isLayoutDetailsModalOpen} />;
};
